import { render, staticRenderFns } from "./InsertMap.vue?vue&type=template&id=5b443f54&"
import script from "./InsertMap.vue?vue&type=script&lang=js&"
export * from "./InsertMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports